

  export default {
    head () {
      return {
        meta: [
          { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ],
        ...{ bodyAttrs: { class: '' }, title: this.$t('title'), titleTemplate: '%s | bonkers.ie' },
        ...this.$store.getters['pageContent/getHead']
      };
    }
  };
